import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Footer from "../footer";
import RegisterVisual from "../Visual/registerVisual";
import { SubmitHandler, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import ApiBanner from "./ApiBanner";
import { DatabaseManufacturer, DatabaseOwnerEntry } from "../../Api/Database";
import { useSession } from "../sessionProvider";
import config from "../../Api/config";
import ReactGA from "react-ga4";
//import useReCaptcha from "../Recaptcha";

let serverUrl = window.location.origin;

type FormInputs = {
    file: FileList,
};

export interface RegisterBrandProps {
    isOwner?: boolean
    redirectTo?: string
}

function RegisterBrand(props: RegisterBrandProps) {
    ReactGA.send({ hitType: "pageview", page: "/register/manufacturer", title: "Register Manufacturer" });

    //const getRecaptchaToken = useReCaptcha(config.recaptchaToken);
    const navigate = useNavigate();
    const notifyError = (err:any) => toast.error(err,{theme:"colored"});
    const notifySuccess = (text:any) => toast.success(text,{theme:"colored"});
   
    const {register, handleSubmit, setError, formState: {errors}} = useForm<FormInputs>();

    const { manufacturerId } = useParams();
    const [copyData, setCopyData] = useState(false);

    const { email,is_onboarded, ownerId } = useSession();
    const [brandData, setBrandData] = useState<DatabaseManufacturer>({
        name: "",
        website_url : "",
        summary :"",
        location:"",
        location_iso:"",
        business_registry_info :"",
        eori:"",
        logo:"",
    });
  
    const changeBrandData = (name: string, data: any): void => {
        if(name == 'location'){
            setBrandData({ ...brandData, [name]: data.toUpperCase() });
        }else{
            setBrandData({ ...brandData, [name]: data });
        }
    };

    useEffect(() => {
        if(props.isOwner) {
            config.API.getOwner(ownerId).then(brand => {
                setBrandData({...brand});
            })
        } else if(manufacturerId) {
            config.API.getManufacturer(ownerId, manufacturerId).then(brand => {
                setBrandData({...brand})
            })
        }
    }, []);


    const onSubmitForm: SubmitHandler<FormInputs> = (data: FormInputs) => { 

        if(props.isOwner) {
            // edit owner data
            config.API.editOwner(ownerId, {...brandData}).then((edited) => {
                if(edited) {
                    notifySuccess("Updated owner details.");
                    navigate('/settings');
                }
            }).catch(error => {
                console.error("Error in update owner API: ", error);
                notifyError("Error in update owner API: " +  error);
            });
        } else if(manufacturerId) {
            config.API.editManufacturer(ownerId, manufacturerId, {...brandData}).then((edited) => {
                if(edited) {
                    notifySuccess("Updated manufacturer '"+brandData.name+"'.");
                    navigate('/settings');
                }
            }).catch(error => {
                console.error("Error in update manufacturer list API: ", error);
                notifyError("Error in update manufacturer list API: " + error);
            });
        } else {
            config.API.addManufacturer(ownerId, {...brandData}).then((id) => {
                //console.log("Successfully created new manufacturer " + id);
                notifySuccess("Registered manufacturer '"+brandData.name+"'.");
                if(props.redirectTo){
                    navigate(props.redirectTo);
                }else{
                    window.location.href = "/products";
                }
                
            }).catch(error => {
                console.error("Error in register manufacturer API: ", error);
                notifyError("Error in register manufacturer API: " + error);
            });
        }
    }    


    function makeForm(): JSX.Element {
        return (<>

            <form className="form" onSubmit={(event: React.FormEvent<HTMLFormElement>) => {
                event.preventDefault();
                handleSubmit(onSubmitForm)(event);
            }} >
                <div>
                    <label> <span className="requiredMark">*</span> {props.isOwner ? "Product Owner's Name" : "Manufacturer Name"} </label>
                    <input type="text" className="issuer-form" name="name" maxLength={400} placeholder={props.isOwner ? "e.g., John Doe" : "e.g., Ace"} value={brandData.name} onChange={(event) => { changeBrandData("name", event.target.value); }} required ></input>
                </div>

                <div>
                    <label> <span className="requiredMark">*</span> Website{" "} </label>
                    <input type="url" className="issuer-form" name="website_url" maxLength={1000} placeholder="e.g., https://www.example.com/" value={brandData.website_url } onChange={(event) => { changeBrandData("website_url", event.target.value); }} required ></input>
                </div>

                <div>
                    <label> <span className="requiredMark">*</span> {props.isOwner ? "Company" : "Manufacturer"} Description{" "} </label>
                    <input type="text" className="issuer-form" name="summary" maxLength={1000} placeholder="e.g., We are a technology company specializing in software development and digital products." value={brandData.summary } onChange={(event) => { changeBrandData("summary", event.target.value); }} required ></input>
                </div>

                <div>
                    <label> <span className="requiredMark">*</span> Location{" "} </label>
                    <input type="text" className="issuer-form" name="location" maxLength={2} placeholder="e.g., US" value={brandData.location } onChange={(event) => { changeBrandData("location", event.target.value); }} required ></input>
                </div>

                <div>
                    <label> Location ISO{" "} </label>
                    <input type="text" className="issuer-form" name="location_iso" maxLength={1000} placeholder="e.g., urn:iso:std:iso:3166:-2:US" value={brandData.location_iso } onChange={(event) => { changeBrandData("location_iso", event.target.value); }} ></input>
                </div>

                <div>
                    <label> Business Registry Link{" "} </label>
                    <input type="url" className="issuer-form" name="business_registry_info" maxLength={1000} placeholder="e.g., https://www.example-registry.com" value={brandData.business_registry_info } onChange={(event) => { changeBrandData("business_registry_info", event.target.value); }}  ></input>
                </div>

                <div>
                    <label> Economic Operators Registration and Identification Number (EORI){" "} </label>
                    <input type="text" className="issuer-form" name="eori" maxLength={1000} placeholder="e.g., 1234567890" value={brandData.eori } onChange={(event) => { changeBrandData("eori", event.target.value); }} ></input>
                </div>

                <div>
                    <label> <span className="requiredMark">*</span> Logo{" "} </label>
                    <input type="url" className="issuer-form" name="logo" maxLength={1000} placeholder="e.g., https://www.example.com/logo.png" value={brandData.logo } onChange={(event) => { changeBrandData("logo", event.target.value); }} required></input>
                </div>

                <button  className="btn btn-primary" type="submit"> {props.isOwner ? "Save changes" : (manufacturerId ? "Save changes" : "Register")}</button>
                
                {is_onboarded &&  <>
                    <button  className="btn btn-secondary" style={{marginBottom:"20px"}} onClick={() => {
                        navigate('/settings');
                    }}> Back</button>
                </>}
               
                
            </form>
        </>)
    }


    return (<>
        <div className="company">

            {props.isOwner ? <>
                <RegisterVisual title={"Edit account settings"} />
            </>:<>
                <RegisterVisual title={(manufacturerId ? "Edit manufacturer " + brandData.name : "Create new manufacturer")} />
            </>}
           
            <div className="explorer">
                {!props.isOwner && <>
                    {/*<button className="btn btn-primary" onClick={() => {
                        config.API.getOwner(ownerId).then(info => setBrandData(info))
                    }}>Copy from owner information</button>*/}

                    <label className="container1">Copy from owner information
                        <input type="checkbox" checked={copyData}  onChange={() => {
                            if(!copyData){
                                config.API.getOwner(ownerId).then(info => setBrandData(info))
                            }else{
                                setBrandData({
                                    name: "",
                                    website_url : "",
                                    summary :"",
                                    location:"",
                                    location_iso:"",
                                    business_registry_info :"",
                                    eori:"",
                                    logo:"",
                                })
                            }
                           
                            setCopyData(!copyData);
                        }}/>
                        <span className="checkmark"></span>
                    </label>
                </>}
                
                {makeForm()}     
            </div>

            {is_onboarded &&  <>
                {/*<p style={{margin:"20px"}}>OR</p>*/}
                <ApiBanner/>
            </>}
            

            <Footer/>
        </div>
    </>);
}

export default RegisterBrand;
